import { useEffect } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { CommandEnum } from '@/types/schema';

import { useContentViewProgressMutation } from '../../graphql/mutations/generated/contentViewProgress';
import { useRecalibrateContentProgressMutation } from '../../modules/course/views/CourseDetails/graphql/mutation/generated/recalibrateContentProgress';
import { Params } from './types';

const useContentAccessed = (params: Params) => {
  const { entityId, pause, recalibrationRequired, sendContentAccessedEvent = true } = params;
  const [, executeContentViewProgressMutation] = useContentViewProgressMutation();
  const [, recalibrateContentProgress] = useRecalibrateContentProgressMutation();
  const [isContentVisited, { on }] = useToggle(false);

  useEffect(() => {
    if (pause || isContentVisited) {
      return;
    }

    const variables = {
      input: [
        {
          command: CommandEnum.ContentAccessed,
          clientTimestamp: new Date().toISOString(),
          entityId,
        },
      ],
    };

    if (sendContentAccessedEvent) {
      executeContentViewProgressMutation(variables).then(() => {
        on();
      });
    }
    recalibrationRequired && recalibrateContentProgress({ entityId });
  }, [
    entityId,
    executeContentViewProgressMutation,
    isContentVisited,
    on,
    pause,
    recalibrateContentProgress,
    recalibrationRequired,
    sendContentAccessedEvent,
  ]);
};

export default useContentAccessed;
